var map = {
	"./fortune-card-Bgblack.png": 99231,
	"./fortune-card-Bgblue.png": 8874,
	"./fortune-card-Bggreen.png": 6509,
	"./fortune-card-Bgorange.png": 61242,
	"./fortune-card-Bgpink.png": 62714,
	"./fortune-card-Bgred.png": 72867,
	"./fortune-card-Bgyellow.png": 78053,
	"./fortune-card-light.png": 53154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90459;